import { render } from "./Paginator.vue?vue&type=template&id=003488de"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"

import "./Paginator.vue?vue&type=style&index=0&id=003488de&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paginator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "003488de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('003488de', __exports__)) {
    console.log('reload')
    api.reload('003488de', __exports__)
  }
  
  module.hot.accept("./Paginator.vue?vue&type=template&id=003488de", () => {
    console.log('re-render')
    api.rerender('003488de', render)
  })

}


export default __exports__